
import $ from 'jquery';
import domready from '../utils/domready.js';
import PowermailCondition from 'powermail-conditions';
import Parsley from 'parsleyjs';
import 'powermail-tabs';
import 'powermail-form';

  function getCookies(){
    var pairs = document.cookie.split(";");
    var cookies = {};
    for (var i=0; i<pairs.length; i++){
      var pair = pairs[i].split("=");
      cookies[pair[0].trim()] = decodeURIComponent(pair[1]).trim();
    }
    return cookies;
  }

  function injectMarketingInformation() {
    var information = {
      date: (new Date()).toISOString(),
      cookies: getCookies(),
      currentUri: window.location.href
    };
    var marketingHiddenField = $(this).find('input.powermail_marketing');
    if (marketingHiddenField) {
      marketingHiddenField.val(JSON.stringify(information));
    }
  }

  function notifyNewsletterSubscribed() {
    var newsletterField = $(this).find('input[name^="tx_powermail_pi1[field][newsletter]"]');
    var newsletterNagger = document.getElementById('newsletter-nagger');
    if (newsletterNagger && newsletterField.length > 0 && newsletterField.is(':checked')) {
      newsletterNagger.notifySubscribed();
    }
  }

  $('form.powermail_form')
    .on('submit', injectMarketingInformation)
    .on('submit', notifyNewsletterSubscribed);

  domready(function() {

    $('form.powermail_form[data-powermail-conditions]').each(function() {
      (new PowermailCondition(this)).ajaxListener();
    });

    document.addEventListener('fit-modal-loaded', function(event) {
      var powermailForms = Polymer.dom(event.target).querySelectorAll('form.powermail_form');
      powermailForms.forEach(function (form) {
        $(form).parsley();
        $(form)
          .on('submit', injectMarketingInformation)
          .on('submit', notifyNewsletterSubscribed);
      });
      var powermailConditionForms = Polymer.dom(event.target).querySelectorAll('form[data-powermail-conditions]');
      powermailConditionForms.forEach(function (form) {
        (new PowermailCondition(form)).ajaxListener();
      });
    });
  });
